import { createSlice } from "@reduxjs/toolkit";

// Initial state for meetingId
const initialState = {
  meetingId: null,
  organizerId: null,
  // The Teams meeting join URL — passed to Recall.ai as the meeting_url.
  joinUrl: null,
};

const meetingSlice = createSlice({
  name: "meeting",
  initialState,
  reducers: {
    setMeetingId: (state, action) => {
      state.meetingId = action.payload;
    },
    setOrganizerId: (state, action) => {
      state.organizerId = action.payload;
    },
    setJoinUrl: (state, action) => {
      state.joinUrl = action.payload;
    },
  },
});

// Export actions and reducer
export const { setMeetingId, setOrganizerId, setJoinUrl } = meetingSlice.actions;
export default meetingSlice.reducer;
